import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ar-watch"
    exact
    path="/business/products/ar-watch"
    component={AsyncPage}
  />,
];
